import NextImage, { ImageLoader, ImageProps } from 'next/image';
import { useRouter } from 'next/router';

export type Props = {} & Omit<ImageProps, 'loader'>;

export default function LocaleAwareImage(props: Props) {
  const { locale } = useRouter();

  // Storybook support
  const isStorybook =
    typeof window !== 'undefined' && window.location.pathname.includes('/iframe.html');
  const tenant = (process.env.NEXT_PUBLIC_TENANT || 'mobiworkx').toLowerCase();
  const localeForStorybook = locale && locale.includes('-') ? locale.toLowerCase() : 'en-gb';

  /**
   * Custom image loader to support locale-aware images.
   * We can't efficiently check the locale-specific images exist within the component, so we need to do it in an API handler.
   */
  const imageLoader: ImageLoader = ({ src, width, quality }) => {
    // Storybook support
    if (isStorybook || !locale) {
      if (!src.startsWith('/assets/')) {
        return `${process.env.NEXT_PUBLIC_ASSET_PREFIX || ''}${src}`;
      }

      const relativeAssetPath = src.replace('/assets/', '');
      const tenantPrefixedPath = `${tenant}/images/`;
      const storybookPath = relativeAssetPath.startsWith(tenantPrefixedPath)
        ? `/assets/${relativeAssetPath}`
        : `/assets/${tenant}/images/${localeForStorybook}/${relativeAssetPath}`;

      return `${process.env.NEXT_PUBLIC_ASSET_PREFIX || ''}${storybookPath}`;
    }

    return `${
      process.env.NEXT_PUBLIC_ASSET_PREFIX || ''
    }/api/locales/${locale?.toLowerCase()}/image?url=${encodeURIComponent(src)}&w=${width}&q=${
      quality || 75
    }`;
  };
  return <NextImage loader={imageLoader} {...props} />;
}
